export default "__VITE_ASSET__CSGM1dND__"